import { Group, Stack } from "@mantine/core"
import { InformationItem, CopyButton } from "@tfg/ui"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { TraceabilityResponses } from "@tfg/types/endpoints/traceability"

import { IconRawMaterial } from "~/components/icons/activities/IconRawMaterial"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useGetTranslation } from "~/utils/translations.ts"

import { isComponentItem, isMaterialItem, isProductItem } from "../utils"

import { MaterialComposition } from "./MaterialComposition"

interface ItemInformationProps {
  item: TraceabilityResponses.TraceabilityRequestItem
  customLabel?: ReactNode
  showTitle?: boolean
}

export const ItemTypeInformation = ({
  item,
  customLabel,
  showTitle = true,
}: ItemInformationProps) => {
  const { t } = useTranslation(["traceability"])
  const label = useGetTranslation(item.itemInformation.type)

  if (isProductItem(item)) {
    return (
      <InformationItem
        title={showTitle ? t("item.product") : undefined}
        value={customLabel ?? label}
      />
    )
  }

  if (isComponentItem(item)) {
    return (
      <InformationItem
        title={showTitle ? t("item.component") : undefined}
        helpHover={<MaterialComposition item={item} />}
        icon={<IconRawMaterial size={16} />}
        value={customLabel ?? label}
      />
    )
  }

  if (isMaterialItem(item)) {
    return (
      <InformationItem
        title={showTitle ? t("item.material_one") : undefined}
        value={customLabel ?? label}
      />
    )
  }

  return null
}

export const OperationItemInformation = () => {
  const { isAdmin, operationItem } = useTraceabilityOperations()

  return (
    <Stack gap="xs" w="100%">
      {isAdmin && (
        <Group>
          {operationItem.operation?.id && (
            <CopyButton
              label="Operation Id"
              size="xs"
              admin={isAdmin}
              copyableText={operationItem.operation.id.toString()}
            />
          )}
        </Group>
      )}
      <ItemTypeInformation item={operationItem.item} />
    </Stack>
  )
}
